import { Flow_0_0_2 } from '@flexus/core';

export const SIL_101: Flow_0_0_2 = {
	id: '101',
	name: 'await_la_decision',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
